import { useMutation, useQueryClient } from 'react-query';
import { loan_application } from '@axo/shared/data-access/types';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { loan_application_api } from '@axo/shared/data-access/api';

export function useClawbackApplication() {
  const api = useAPI();
  const client = useQueryClient();

  const patch = {
    Status: loan_application.ApplicationStatus.ApplicationStatusLoanClawbacked,
  };

  return useMutation(
    (applicationID: string) =>
      loan_application_api.patchLoanApplication(api)(applicationID, patch),
    {
      onSuccess: (_, applicationID) => {
        return client.invalidateQueries(
          applicationKeys.detail({
            applicationID: applicationID,
          })
        );
      },
    }
  );
}
